import { useMemo } from 'react';

export const useFilteredDataByArea = <T extends { storeId: string }>(
  data: T[] | undefined,
  storesByArea: string[],
  selectedStores: string[],
): T[] => {
  return useMemo(() => {
    if (!data) return [];

    const areaFiltered = data.filter((item) => storesByArea.includes(item.storeId));

    if (selectedStores.length === 0) {
      return areaFiltered;
    }

    return areaFiltered.filter((item) => selectedStores.includes(item.storeId));
  }, [data, storesByArea, selectedStores]);
};
